
<script setup>

  import AudioPlayer from '../components/audio-player.vue';

  import audio from '../audio/columbus-*.mp3';

  import track from '../audio/columbus-*.vtt';

  const players = [ {

    id: 1,

    title: 'Fond Memories',

    source: 'Source: Interview with Columbus Tutt, August 1, 2007.'

  }, {

    id: 2,

    title: 'Seeing Old Friends, Making New Ones',

    source: 'Source: Interview with Columbus Tutt, August 1, 2007.'

  }, {

    id: 3,

    title: 'Nice Getaway for Black Folk',

    source: 'Source: Interview with Columbus Tutt, 2022.'

  }, {

    id: 4,

    title: 'I Remember the Dance Hall and the Cottages',

    source: 'Source: Interview with Columbus Tutt, 2022.'

  } ].map( obj => ( { ...obj, audio: audio[ obj.id ], track: track[ obj.id ] } ) );

</script>

<template>

  <p>Visitor to Lewis Mountain</p>

  <div v-for="{ audio, track, title, source } in players" class="mt-6" >

    <h4 class="font-bold">{{ title }}</h4>

    <AudioPlayer class="mt-4" :src="audio" :track="track" />

    <div class="mt-4 text-xs italic">{{ source }}</div>

  </div>

</template>
